<template>
    <div>
        <v-card class="mb-4 rounded elevation-2 border" color="white">
                  <!-- Header / Title Section -->
                  <v-card-title class="d-flex flex-wrap align-center justify-space-between py-3 px-4 bg-grey-lighten-4">
                    <div class="d-flex flex-column mb-1 mb-sm-0">
                      <div class="text-h6 font-weight-bold" :style="{ color: getThemeColor }">
                        <template v-if="selectedCase">
                          {{ selectedCase.applicant || selectedCase.clientName || 'Client' }}
                          <span class="text-caption font-weight-medium text-grey-darken-1 mx-1">VS</span>
                          {{ selectedCase.respondent || selectedCase.defendantName || 'Respondent' }}
                        </template>
                        <template v-else>
                          Legal {{ matterLabel }} Billing & Trust Accounting Ledger
                        </template>
                      </div>
                      
                      <div v-if="selectedCase" class="text-caption text-grey-darken-1 font-weight-medium">
                        Ref: {{ selectedCase.internalRef || 'N/A' }}
                      </div>
                    </div>

                    <!-- Status & Phase Chips -->
                    <!-- <div v-if="selectedCase" class="d-flex align-center flex-wrap gap-2">
                     
                      <v-btn
                      dark
                        v-if="selectedCase.matterPhase"
                        
                        :color="selectedCase.matterPhase?.color || 'primary'"
                        variant="flat"
                        class="font-weight-medium"
                        small
                      >
                        <-- <v-icon start size="14">mdi-clock-outline</v-icon> >
                        Phase: {{ selectedCase.matterPhase?.name }}
                      </v-btn>
                    </div> -->
                    <!-- Print Invoice Button -->
                    <div class="d-flex align-center flex-wrap gap-2 mt-2 mt-sm-0" v-if="selectedCase">
                      <v-chip
                        color="primary"
                        variant="tonal"
                        size="small"
                        class="font-weight-medium"
                        prepend-icon="mdi-text-short"
                      >
                        <span class="text-truncate" style="max-width: 300px;">
                          <ProFormaGenerator :invoice="selectedCase" 
                          :title="selectedCase.invoice_no ? 'Invoice' : 'Quotation'" 
                          :buttunWithText="true"></ProFormaGenerator>
                        </span>
                      </v-chip>
                    </div>
                  </v-card-title>

                  <v-divider></v-divider>

                  <!-- Details Grid -->
                  <v-card-text v-if="selectedCase" class="py-3 px-4">
                    <v-row dense>
                      <v-col cols="12" sm="6" md="3">
                        <div class="text-caption text-grey-darken-1">Court Case No</div>
                        <div class="text-body-2 font-weight-medium">
                          <v-icon size="16" class="mr-1 text-grey">mdi-gavel</v-icon>
                          {{ selectedCase.courtCaseNo || 'N/A' }}
                        </div>
                      </v-col>

                      <v-col cols="12" sm="6" md="3">
                        <div class="text-caption text-grey-darken-1">SAPS Case No</div>
                        <div class="text-body-2 font-weight-medium">
                          <v-icon size="16" class="mr-1 text-grey">mdi-shield-badge-outline</v-icon>
                          {{ selectedCase.sapsCaseNo || 'N/A' }}
                        </div>
                      </v-col>

                      <v-col cols="12" sm="6" md="3">
                        <div class="text-caption text-grey-darken-1">Seat of Court</div>
                        <div class="text-body-2 font-weight-medium text-truncate">
                          <v-icon size="16" class="mr-1 text-grey">mdi-map-marker-outline</v-icon>
                          {{ selectedCase.seat_of_court ? `${selectedCase.seat_of_court}` : '' }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
    </div>
</template>

<script>
import ProFormaGenerator from '@/modules/CaseManager/ProFormaGenerator.vue'

export default{
    props:{
        selectedCase:{
            default: null
        }
    },
    components:{
      ProFormaGenerator
    },
    computed:{
        getThemeColor(){
            return this.$store.getters.getThemeColor
        }
    },
    data: ()=>({
        matterLabel: "case"
    })
}
</script>